import { UserService } from './../../../services/user.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroupDirective, NgForm, FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { MaterialModule } from '../../../modules/catch-core/third-party/material/material.module';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.css'],
  standalone: false,
})
export class PasswordResetComponent extends BaseComponent implements OnInit {
  // UI bind properties
  passwordSent: boolean = false;
  sendButtonEnabled: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService,
  ) {
    super();
  }

  emailFormControl = new FormControl('', [Validators.required, Validators.email]);

  matcher = new MyErrorStateMatcher();

  ngOnInit() {
    this.sendButtonEnabled = true;
    this.passwordSent = false;
    setTimeout(() => {
      this.backToLoginPage();
    }, 300000); // Redirect to login page after 5 minutes
  }

  onSubmit() {
    if (this.emailFormControl.invalid) {
      return;
    } else {
      this.passwordSent = true;
      this.sendButtonEnabled = false;
      this.resetPassword(this.emailFormControl.value);
    }
  }

  private resetPassword(userName: string | null): void {
    if (!userName) return;
    this.userService.resetPassword(userName).subscribe(
      (data) => {
        // Handle the successful result here
        console.log('Password reset successfully', data);
      },
      (err) => {
        // Handle the error here
        console.log('Error resetting password', err);
      },
    );
  }

  public enableSend(): void {
    this.sendButtonEnabled = true;
    this.passwordSent = false;
  }

  public backToLoginPage(): void {
    this.router.navigate(['/']);
  }
}
